"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CloudUpload_1 = __importDefault(require("@material-ui/icons/CloudUpload"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var useStyles_1 = __importDefault(require("./useStyles"));
var useOnDeleteFile_1 = __importDefault(require("./hooks/useOnDeleteFile"));
var Icon = function (props) {
    var hasFile = props.hasFile, inputRef = props.inputRef, setFileName = props.setFileName, showControlIcon = props.showControlIcon;
    var classes = (0, useStyles_1.default)();
    var onDeleteFile = (0, useOnDeleteFile_1.default)(inputRef, setFileName);
    if (!showControlIcon)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null, hasFile ? (react_1.default.createElement(Delete_1.default, { className: classes.icon, onClick: function (e) { return onDeleteFile(e); } })) : (react_1.default.createElement(CloudUpload_1.default, { className: classes.icon }))));
};
exports.default = Icon;
